<template>
  <div>
    <el-form ref="form">
      <div>
        <el-space wrap>
          <el-form-item label="分类:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectBlockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:">
            <el-select v-model="obj.selectedIndustryValue" @change="handleSelectChange" style="width:180px">
              <el-option v-for="item in obj.selectIndustryList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指数:">
            <el-select v-model="obj.selectedIndexValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectIndexList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区:">
            <el-select v-model="obj.selectedDistrictValue" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.selectDistrictList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleSubmit" style="width:80px">
              <el-icon class="el-input__icon">
                <refresh /> 筛 选
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <el-tag type="warning" size="small" style="margin-bottom: 20px;">最多可添加8个条件，请注意指标单位</el-tag>
      <div>
        <el-space wrap>
          <el-form-item label="基本指标:">
            <el-select v-model="obj.basicValue" @change="handleBasicValueChange" placeholder="请选择" style="width:200px">
              <el-option v-for="item in obj.basicList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.basicDayValue" @change="handleBasicDayValueChange" placeholder="范围"
              style="width:120px">
              <el-option v-for="item in obj.basicDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.basicSymbolsValue" @change="handleBasicSymbolsChange" placeholder="符号"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.basicAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddBasic">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div>
        <el-space wrap>
          <el-form-item label="收益指标:">
            <el-select v-model="obj.selectedJRValue" placeholder="请选择" @change="handleJRChange" style="width:200px">
              <el-option v-for="item in obj.selectJRList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRDayValue" placeholder="范围" @change="handleJRDayChange"
              style="width:120px">
              <el-option v-for="item in obj.selectJRDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRSymbolsValue" placeholder="符号" @change="handleJRSymbolsChange"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.selectedJRAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddJR">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div>
        <el-space wrap>
          <el-form-item label="财务指标:">
            <el-select v-model="obj.financeValue" @change="handleFinanceValueChange" placeholder="请选择"
              style="width:200px">
              <el-option v-for="item in obj.financeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.financeSymbolsValue" @change="handleFinanceSymbolsChange" placeholder="符号"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.financeAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddFinance">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <div>
        <el-space wrap>
          <el-form-item label="技术指标:">
            <el-select v-model="obj.indicatorsValue" placeholder="请选择" @change="handleTechnicalChange"
              style="width:180px">
              <el-option-group v-for="group in obj.indicatorsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <el-button type="primary" @click="handleAddTechnical">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
          <el-form-item label="形态指标:">
            <el-select v-model="obj.patternsValue" placeholder="请选择" @change="handlePatternChange" style="width:155px">
              <el-option-group v-for="group in obj.patternsList" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <el-button type="primary" @click="handleAddPattern">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
      <!-- <div>
        <el-space wrap>
          <el-form-item label="金融指标:">
            <el-select v-model="obj.selectedJRValue" placeholder="请选择" @change="handleJRChange" style="width:200px">
              <el-option v-for="item in obj.selectJRList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRDayValue" placeholder="范围" @change="handleJRDayChange"
              style="width:120px">
              <el-option v-for="item in obj.selectJRDayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedJRSymbolsValue" placeholder="符号" @change="handleJRSymbolsChange"
              style="width:100px">
              <el-option v-for="item in obj.symbolsList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input-number v-model="obj.selectedJRAmount" placeholder="数量" style="width: 160px;">
            </el-input-number>
            <el-button type="primary" @click="handleAddJR">
              <el-icon class="el-input__icon">
                <refresh /> 添加
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div> -->
      <div style="width: 1400px;">
        <el-space wrap>
          <el-form-item label="" v-for="data in obj.pickingList" :key="data">
            <el-input v-model="data.label" :disabled="true" style="width:260px" />
            <el-button type="danger" @click="del(data)">删除</el-button>
          </el-form-item>
        </el-space>
      </div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">数据截至到 {{ obj.date }}</el-tag>
      <div>
        <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
          :style="'height:' + (this.$store.state.windowHeight - 550) + 'px'" :cell-style="cellStyle"
          @row-click="handleRowClick">
          <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
          <el-table-column fixed label="名称" prop="name" width="100px" align="right" sortable />
          <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
          <el-table-column label="最新" prop="close" width="80px" align="right" />
          <el-table-column label="涨跌" prop="chg" width="80px" align="right" sortable />
          <el-table-column label="涨跌幅" prop="chgPct" align="right" width="100px" :sort-method="customPctSort"
            sortable />
          <el-table-column label="开盘" prop="open" width="80px" align="right" />
          <el-table-column label="最低" prop="low" width="80px" align="right" />
          <el-table-column label="最高" prop="high" width="80px" align="right" />
          <el-table-column label="成交量" prop="vol" width="90px" align="right" :sort-method="customVolSort" sortable />
          <el-table-column label="成交额" prop="turnover" width="100px" align="right" :sort-method="customTurnoverSort" sortable />
          <el-table-column label="前收" prop="preClose" width="80px" align="right" />
          <el-table-column label="趋势度" prop="trend_ma1" width="100px" align="right" sortable/>
          <el-table-column label="换手率" prop="turnoverRate_ma1" width="100px" align="right" :sort-method="customTurnoverRateSort" sortable/>
          <el-table-column label="振幅" prop="amplitude" width="100px" align="right" :sort-method="customAmplitudeSort" sortable/>
          <el-table-column prop="industry" label="行业" width="120px" align="right" />
          <el-table-column prop="index" label="指数" width="180px" align="right" />
          <el-table-column prop="district" label="地区" width="80px" align="right" />
        </el-table>
        <el-pagination background layout="prev, pager, next" :page-size="obj.limit" :total="obj.total"
          :current-page="obj.page" class="mt-16" @current-change="handlePageChange"></el-pagination>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { bigNumberTransform } from '../util/base'
import { ElMessage } from 'element-plus'
import { findObjByField } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      total: 0,
      page: 1,
      limit: 9,
      selectBlockList: [
        {
          value: 'all',
          label: '全部A股'
        },
        {
          value: 'shse',
          label: '上证A股'
        },
        {
          value: 'szse',
          label: '深证A股'
        },
        {
          value: 'bse',
          label: '北证A股'
        },
        {
          value: 'shse_zb',
          label: '上证主板'
        },
        {
          value: 'szse_zb',
          label: '深证主板'
        },
        {
          value: 'shse_kcb',
          label: '科创版'
        },
        {
          value: 'szse_cyb',
          label: '创业版'
        },
      ],
      selectedBlockValue: 'all',
      selectIndexList: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'hs300',
          label: '沪深300'
        },
        {
          value: 'sz50',
          label: '上证50'
        },
        {
          value: 'zz500',
          label: '中证500'
        },
        {
          value: 'zz1000',
          label: '中证1000'
        },
        {
          value: 'cy300',
          label: '创业300'
        },
        {
          value: 'kc50',
          label: '科创50'
        },
        {
          value: 'bz50',
          label: '北证50'
        },
      ],
      selectedIndexValue: 'all',
      selectIndustryList: [
        { 'value': 'all', 'label': '全部' },
        { 'value': '煤炭开采', 'label': '1002 煤炭开采' },
        { 'value': '焦炭加工', 'label': '1005 焦炭加工' },
        { 'value': '油气开采', 'label': '1007 油气开采' },
        { 'value': '石油化工', 'label': '1011 石油化工' },
        { 'value': '油服工程', 'label': '1008 油服工程' },
        { 'value': '日用化工', 'label': '1016 日用化工' },
        { 'value': '化纤', 'label': '1019 化纤' },
        { 'value': '化学原料', 'label': '1026 化学原料' },
        { 'value': '化学制品', 'label': '1034 化学制品' },
        { 'value': '塑料', 'label': '1044 塑料' },
        { 'value': '橡胶', 'label': '1051 橡胶' },
        { 'value': '农用化工', 'label': '1055 农用化工' },
        { 'value': '非金属材料', 'label': '1104 非金属材料' },
        { 'value': '冶钢原料', 'label': '1062 冶钢原料' },
        { 'value': '普钢', 'label': '1065 普钢' },
        { 'value': '特钢', 'label': '1069 特钢' },
        { 'value': '工业金属', 'label': '1071 工业金属' },
        { 'value': '贵金属', 'label': '1075 贵金属' },
        { 'value': '能源金属', 'label': '1078 能源金属' },
        { 'value': '稀有金属', 'label': '1082 稀有金属' },
        { 'value': '金属新材料', 'label': '1087 金属新材料' },
        { 'value': '水泥', 'label': '1091 水泥' },
        { 'value': '玻璃玻纤', 'label': '1094 玻璃玻纤' },
        { 'value': '装饰建材', 'label': '1097 装饰建材' },
        { 'value': '种植业', 'label': '1106 种植业' },
        { 'value': '养殖业', 'label': '1111 养殖业' },
        { 'value': '林业', 'label': '1115 林业' },
        { 'value': '渔业', 'label': '1116 渔业' },
        { 'value': '饲料', 'label': '1119 饲料' },
        { 'value': '农产品加工', 'label': '1123 农产品加工' },
        { 'value': '动物保健', 'label': '1127 动物保健' },
        { 'value': '酿酒', 'label': '1130 酿酒' },
        { 'value': '饮料乳品', 'label': '1136 饮料乳品' },
        { 'value': '调味品', 'label': '1139 调味品' },
        { 'value': '休闲食品', 'label': '1140 休闲食品' },
        { 'value': '食品加工', 'label': '1144 食品加工' },
        { 'value': '纺织制造', 'label': '1151 纺织制造' },
        { 'value': '服装家纺', 'label': '1157 服装家纺' },
        { 'value': '饰品', 'label': '1162 饰品' },
        { 'value': '造纸', 'label': '1167 造纸' },
        { 'value': '包装印刷', 'label': '1171 包装印刷' },
        { 'value': '家居用品', 'label': '1177 家居用品' },
        { 'value': '文娱用品', 'label': '1180 文娱用品' },
        { 'value': '白色家电', 'label': '1184 白色家电' },
        { 'value': '黑色家电', 'label': '1187 黑色家电' },
        { 'value': '小家电', 'label': '1190 小家电' },
        { 'value': '厨卫电器', 'label': '1194 厨卫电器' },
        { 'value': '家电零部件', 'label': '1198 家电零部件' },
        { 'value': '一般零售', 'label': '1200 一般零售' },
        { 'value': '商业物业经营', 'label': '1204 商业物业经营' },
        { 'value': '专业连锁', 'label': '1205 专业连锁' },
        { 'value': '贸易', 'label': '1206 贸易' },
        { 'value': '电子商务', 'label': '1207 电子商务' },
        { 'value': '乘用车', 'label': '1212 乘用车' },
        { 'value': '商用车', 'label': '1215 商用车' },
        { 'value': '汽车零部件', 'label': '1218 汽车零部件' },
        { 'value': '汽车服务', 'label': '1224 汽车服务' },
        { 'value': '摩托车及其他', 'label': '1227 摩托车及其他' },
        { 'value': '化学制药', 'label': '1231 化学制药' },
        { 'value': '生物制品', 'label': '1234 生物制品' },
        { 'value': '中药', 'label': '1256 中药' },
        { 'value': '医药商业', 'label': '1252 医药商业' },
        { 'value': '医疗器械', 'label': '1241 医疗器械' },
        { 'value': '医疗服务', 'label': '1247 医疗服务' },
        { 'value': '医疗美容', 'label': '1257 医疗美容' },
        { 'value': '电机制造', 'label': '1261 电机制造' },
        { 'value': '电池', 'label': '1262 电池' },
        { 'value': '电网设备', 'label': '1268 电网设备' },
        { 'value': '光伏设备', 'label': '1275 光伏设备' },
        { 'value': '风电设备', 'label': '1282 风电设备' },
        { 'value': '其他发电设备', 'label': '1285 其他发电设备' },
        { 'value': '地面兵装', 'label': '1287 地面兵装' },
        { 'value': '航空装备', 'label': '1288 航空装备' },
        { 'value': '航天装备', 'label': '1289 航天装备' },
        { 'value': '航海装备', 'label': '1290 航海装备' },
        { 'value': '军工电子', 'label': '1291 军工电子' },
        { 'value': '轨交设备', 'label': '1293 轨交设备' },
        { 'value': '通用设备', 'label': '1294 通用设备' },
        { 'value': '专用设备', 'label': '1303 专用设备' },
        { 'value': '工程机械', 'label': '1310 工程机械' },
        { 'value': '自动化设备', 'label': '1313 自动化设备' },
        { 'value': '半导体', 'label': '1319 半导体' },
        { 'value': '消费电子', 'label': '1326 消费电子' },
        { 'value': '光学光电', 'label': '1329 光学光电' },
        { 'value': '元器件', 'label': '1333 元器件' },
        { 'value': '其他电子', 'label': '1336 其他电子' },
        { 'value': '通信设备', 'label': '1338 通信设备' },
        { 'value': '通信工程', 'label': '1347 通信工程' },
        { 'value': '电信服务', 'label': '1344 电信服务' },
        { 'value': 'IT设备', 'label': '1352 IT设备' },
        { 'value': '软件服务', 'label': '1355 软件服务' },
        { 'value': '云服务', 'label': '1359 云服务' },
        { 'value': '产业互联网', 'label': '1364 产业互联网' },
        { 'value': '游戏', 'label': '1369 游戏' },
        { 'value': '广告营销', 'label': '1370 广告营销' },
        { 'value': '影视院线', 'label': '1373 影视院线' },
        { 'value': '数字媒体', 'label': '1376 数字媒体' },
        { 'value': '出版业', 'label': '1380 出版业' },
        { 'value': '广播电视', 'label': '1384 广播电视' },
        { 'value': '全国性银行', 'label': '1386 全国性银行' },
        { 'value': '地方性银行', 'label': '1389 地方性银行' },
        { 'value': '证券', 'label': '1394 证券' },
        { 'value': '保险', 'label': '1395 保险' },
        { 'value': '多元金融', 'label': '1396 多元金融' },
        { 'value': '房屋建设', 'label': '1406 房屋建设' },
        { 'value': '基础建设', 'label': '1407 基础建设' },
        { 'value': '专业工程', 'label': '1410 专业工程' },
        { 'value': '工程咨询服务', 'label': '1415 工程咨询服务' },
        { 'value': '装修装饰', 'label': '1416 装修装饰' },
        { 'value': '房地产开发', 'label': '1418 房地产开发' },
        { 'value': '房产服务', 'label': '1422 房产服务' },
        { 'value': '体育', 'label': '1427 体育' },
        { 'value': '教育培训', 'label': '1428 教育培训' },
        { 'value': '酒店餐饮', 'label': '1429 酒店餐饮' },
        { 'value': '旅游', 'label': '1432 旅游' },
        { 'value': '专业服务', 'label': '1436 专业服务' },
        { 'value': '公路铁路', 'label': '1442 公路铁路' },
        { 'value': '航空机场', 'label': '1446 航空机场' },
        { 'value': '航运港口', 'label': '1449 航运港口' },
        { 'value': '物流', 'label': '1452 物流' },
        { 'value': '电力', 'label': '1459 电力' },
        { 'value': '燃气', 'label': '1467 燃气' },
        { 'value': '水务', 'label': '1468 水务' },
        { 'value': '环保设备', 'label': '1470 环保设备' },
        { 'value': '环境治理', 'label': '1471 环境治理' },
        { 'value': '环境监测', 'label': '1476 环境监测' },
        { 'value': '综合类', 'label': '1478 综合类' }
      ],
      selectedIndustryValue: 'all',
      selectDistrictList: [
        {  
          value: 'all',  
          label: '全部'  
        },  
        {  
          value: '北京',  
          label: '北京'  
        },  
        {  
          value: '上海',  
          label: '上海'  
        },  
        {  
          value: '广东',  
          label: '广东'
        },  
        {  
          value: '深圳',  
          label: '深圳'  
        },  
        {  
          value: '重庆',  
          label: '重庆'  
        },  
        {  
          value: '江苏',  
          label: '江苏'
        },  
        {  
          value: '浙江',  
          label: '浙江'
        },  
        {  
          value: '山东',  
          label: '山东'
        },  
        {  
          value: '天津',  
          label: '天津'  
        },  
        {  
          value: '湖北',  
          label: '湖北'
        },  
        {  
          value: '四川',  
          label: '四川'
        },  
        {  
          value: '陕西',  
          label: '陕西'
        },  
        {  
          value: '福建',  
          label: '福建'
        }, 
        {  
          value: '辽宁',  
          label: '辽宁'
        },  
        {  
          value: '黑龙江',  
          label: '黑龙江'  
        },  
        {  
          value: '新疆',  
          label: '新疆'  
        },  
        {  
          value: '吉林',  
          label: '吉林'  
        },  
        {  
          value: '甘肃',  
          label: '甘肃'  
        },  
        {  
          value: '青海',  
          label: '青海'  
        },  
        {  
          value: '广西',  
          label: '广西'  
        },  
        {  
          value: '河北',  
          label: '河北'  
        },  
        {  
          value: '河南',  
          label: '河南'  
        },  
        {  
          value: '宁夏',  
          label: '宁夏'  
        },  
        {  
          value: '山西',  
          label: '山西'  
        },  
        {  
          value: '湖南',  
          label: '湖南'  
        },  
        {  
          value: '江西',  
          label: '江西'  
        },  
        {  
          value: '安徽',  
          label: '安徽'  
        },  
        {  
          value: '云南',  
          label: '云南'  
        },  
        {  
          value: '贵州',  
          label: '贵州'  
        },  
        {  
          value: '海南',  
          label: '海南'  
        },  
        {  
          value: '西藏',  
          label: '西藏'  
        },  
        {  
          value: '内蒙',  
          label: '内蒙'  
        },
      ],
      selectedDistrictValue: 'all',
      // 基本指标
      basicList: [
        {
          value: 'chgPct',
          label: '涨幅(%)'
        },
        {
          value: 'chg',
          label: '涨跌(元)'
        },
        {
          value: 'chg2Pct',
          label: '实体涨幅(%)'
        },
        {
          value: 'amplitude',
          label: '振幅(%)'
        },
        {
          value: 'amplitudePoint',
          label: '振幅(元)'
        },
        {
          value: 'trend',
          label: '趋势度(-1~1)'
        },
        {
          value: 'turnoverRate',
          label: '换手率(%)'
        },
        // {
        //   value: 'capital',
        //   label: '资金净流入'
        // },
        // {
        //   value: 'capitalPct',
        //   label: '资金净流入比(%)'
        // },
        {
          value: 'vol',
          label: '成交量(万手)'
        },
        {
          value: 'volChg',
          label: '成交量增量(万手)'
        },
        {
          value: 'volChgPct',
          label: '成交量增比(%)'
        },
        {
          value: 'turnover',
          label: '成交额(亿)'
        },
        {
          value: 'turnoverChg',
          label: '成交额增量(亿)'
        },
        {
          value: 'turnoverChgPct',
          label: '成交额增比(%)'
        },
      ],
      basicValue: '',
      basicLabel: '',
      basicDayList: [
        {
          value: '1',
          label: '最近1日'
        },
        {
          value: '3',
          label: '最近3日'
        },
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        // {
        //   value: '60',
        //   label: '最近60日'
        // }
      ],
      basicDayValue: '',
      basicDayLabel: '',
      basicSymbolsValue: "",
      basicSymbolsLabel: "",
      basicAmount: "",
      // 财务指标
      financeList: [
        {
          value: 'PETTM',
          label: '市盈(TTM)'
        },
        {
          value: 'PEDynamic',
          label: '市盈(动)'
        },
        {
          value: 'PEStatic',
          label: '市盈(静)'
        },
        {
          value: 'floatingStock',
          label: '流通股(亿)'
        },
        {
          value: 'circulatingMarketValue',
          label: '流通市值(亿)'
        },
        {
          value: 'totalAssets',
          label: '总资产(亿)'
        },
        {
          value: 'netAssets',
          label: '净资产(亿)'
        },
        {
          value: 'debtRatio',
          label: '资产负债率%'
        },
        {
          value: 'revenue',
          label: '营业收入(亿)'
        },
        {
          value: 'cost',
          label: '营业成本(亿)'
        },
        {
          value: 'profit',
          label: '营业利润(亿)'
        },
        {
          value: 'investmentIncome',
          label: '投资收益(亿)'
        },
        {
          value: 'totalProfits',
          label: '利润总额(亿)'
        },
        {
          value: 'profitAfterTax',
          label: '税后利润(亿)'
        },
        {
          value: 'netProfit',
          label: '净利润(亿)'
        },
        {
          value: 'nonGAAPNetProfit',
          label: '扣非净利润(亿)'
        },
        {
          value: 'retainedEarnings',
          label: '未分利润(亿)'
        },
        {
          value: 'operatingCashFlow',
          label: '经营现金流(亿)'
        },
        {
          value: 'totalCashFlow',
          label: '总现金流(亿)'
        },
        {
          value: 'profitYoY',
          label: '利润同比%'
        },
        {
          value: 'revenueYoY',
          label: '收入同比%'
        },
        {
          value: 'PB',
          label: '市净率'
        },
        {
          value: 'PCF',
          label: '市现率'
        },
        {
          value: 'PS',
          label: '市销率'
        },
        {
          value: 'EPS',
          label: '每股收益'
        },
        {
          value: 'ROE',
          label: '净资产收益率%'
        },
        {
          value: 'grossProfitMargin',
          label: '毛利率%'
        },
        {
          value: 'operatingProfitMargin',
          label: '营业利润率%'
        },
        {
          value: 'netProfitMargin',
          label: '净利润率%'
        },
      ],
      financeValue: '',
      financeLabel: '',
      financeSymbolsValue: '',
      financeSymbolsLabel: '',
      financeAmount: '',
      // 技术指标
      indicatorsList: [
        {
          label: 'MA指标',
          options: [
            {
              value: 'MA_2_LONG',
              label: 'MA多头排列(2均线)'
            },
            {
              value: 'MA_2_SHORT',
              label: 'MA空头排列(2均线)'
            },
            {
              value: 'MA_LONG',
              label: 'MA多头排列(3均线)'
            },
            {
              value: 'MA_SHORT',
              label: 'MA空头排列(3均线)'
            },
            {
              value: 'MA_CROSSUP',
              label: 'MA金叉'
            },
            {
              value: 'MA_CROSSDOWN',
              label: 'MA死叉'
            },
            {
              value: 'Up_MA1',
              label: 'MA5上方收盘'
            },
            {
              value: 'Down_MA1',
              label: 'MA5下方收盘'
            },
            {
              value: 'Up_MA2',
              label: 'MA10上方收盘'
            },
            {
              value: 'Down_MA2',
              label: 'MA10下方收盘'
            },
            {
              value: 'Up_MA3',
              label: 'MA20上方收盘'
            },
            {
              value: 'Down_MA3',
              label: 'MA20下方收盘'
            },
          ],
        },
        {
          label: 'BOLL指标',
          options: [
            {
              value: 'UP_BOLL_MID',
              label: '布林中轨上方收盘'
            },
            {
              value: 'DOWN_BOLL_MID',
              label: '布林中轨下方收盘'
            },
            {
              value: 'BOLL_CROSSUP_MID',
              label: '突破布林中轨'
            },
            {
              value: 'BOLL_CROSSDOWN_MID',
              label: '跌破布林中轨'
            },
          ],
        },
        {
          label: 'MACD指标',
          options: [
            {
              value: 'MACD_CROSSUP',
              label: 'MACD金叉'
            },
            {
              value: 'MACD_CROSSDOWN',
              label: 'MACD死叉'
            },
            {
              value: 'MACD_RED',
              label: 'MACD红柱'
            },
            {
              value: 'MACD_GREEN',
              label: 'MACD绿柱'
            },
          ],
        },
        {
          label: 'KDJ指标',
          options: [
            {
              value: 'KDJ_CROSSUP',
              label: 'KDJ金叉'
            },
            {
              value: 'KDJ_CROSSDOWN',
              label: 'KDJ死叉'
            },
          ],
        },
      ],
      indicatorsValue: '',
      indicatorsLabel: '',
      // 形态指标
      patternsList: [
        {
          label: '三k线组合',
          options: [
            {
              value: 'MorningStar',
              label: '早晨之星'
            },
            {
              value: 'EveningStar',
              label: '黄昏之星'
            },
          ],
        },
        {
          label: '两k线组合',
          options: [
            {
              value: 'EngulfingUp',
              label: '看涨吞没'
            },
            {
              value: 'EngulfingDown',
              label: '看跌吞没'
            },
            {
              value: 'Piercing',
              label: '向上刺透'
            },
            {
              value: 'DarkCloudCover',
              label: '乌云压顶'
            },
          ],
        },
        {
          label: '单k线模式',
          options: [
            {
              value: 'MarubozuUp',
              label: '实体饱满阳'
            },
            {
              value: 'MarubozuDown',
              label: '实体饱满阴'
            },
            {
              value: 'Hammer',
              label: '锤子形态'
            },
            {
              value: 'ShootingStar',
              label: '流星形态'
            },
            {
              value: 'Dragonfly',
              label: '蜻蜓十字'
            },
            {
              value: 'Gravestone',
              label: '墓碑十字'
            },
            {
              value: 'Dojistar',
              label: '十字星'
            },
          ],
        },
        {
          label: '其他',
          options: [
            {
              value: 'up',
              label: '收阳'
            },
            {
              value: 'down',
              label: '收阴'
            },
            {
              value: '2up',
              label: '二连阳'
            },
            {
              value: '2down',
              label: '二连阴'
            },
            {
              value: '3up',
              label: '三连阳'
            },
            {
              value: '3down',
              label: '三连阴'
            },
          ],
        },
      ],
      patternsValue: '',
      patternsLabel: '',
      // 金融指标
      selectJRList: [
        {
          value: 'rtn',
          label: '收益率(%)'
        },
        {
          value: 'std',
          label: '波动率(%)'
        },
        {
          value: 'sharp',
          label: '夏普比(收益率/波动率)'
        },
        // {
        //   value: 'alpha',
        //   label: 'Alpha'
        // },
        // {
        //   value: 'beta',
        //   label: 'Beta'
        // },
        // {
        //   value: 'correlation',
        //   label: '相关系数'
        // },
      ],
      selectedJRValue: '',
      selectedJRLabel: '',
      selectJRDayList: [
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        // {
        //   value: '60',
        //   label: '最近60日'
        // }
      ],
      selectedJRDayValue: '',
      selectedJRDayLabel: '',
      selectedJRSymbolsValue: '',
      selectedJRSymbolsLabel: '',
      selectedJRAmount: '',
      // 其他
      symbolsList: [
        {
          value: '>',
          label: '大于'
        },
        {
          value: '>=',
          label: '大于等于'
        },
        {
          value: '<',
          label: '小于'
        },
        {
          value: '<=',
          label: '小于等于'
        },
        {
          value: '!=',
          label: '不等于'
        },
        {
          value: '=',
          label: '等于'
        },
        // {
        //   value: 'head',
        //   label: '前'
        // },
        // {
        //   value: 'tail',
        //   label: '后'
        // },
      ],
      pickingList: [],
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.pickingData === '') {
        // 无缓存，从后台请求数据
        // requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let block = obj.selectedBlockValue
      let index = obj.selectedIndexValue
      block = block + "," + index
      if (obj.selectedIndustryValue != "all") {
        block = block + "," + obj.selectedIndustryValue
      }
      if (obj.selectedDistrictValue != "all") {
        block = block + "," + obj.selectedDistrictValue
      }

      var basicPicking = []
      var financePicking = []
      var technicalPicking = []
      var patternPicking = []
      var returnPicking = []
      for (var item of obj.pickingList) {
        if (item.category == "basic") {
          basicPicking.push(item.value)
        } else if (item.category == "finance") {
          financePicking.push(item.value)
        } else if (item.category == "technical") {
          technicalPicking.push(item.value)
        } else if (item.category == "pattern") {
          patternPicking.push(item.value)
        } else if (item.category == "return") {
          returnPicking.push(item.value)
        }
      }
      let formData = new FormData()
      formData.append("block", block)
      formData.append("basic_indicators", basicPicking.join(" "))
      formData.append("financial_indicators", financePicking.join(" "))
      formData.append("technical_indicators", technicalPicking.join(" "))
      formData.append("patterns_indicators", patternPicking.join(" "))
      formData.append("return_indicators", returnPicking.join(" "))
      formData.append("page", obj.page)
      formData.append("limit", obj.limit)
      http({
        url: `/picking`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的合约')
        }
        processData(res.data.data)
        setStore()
      }).catch(error => {
        // 处理错误  
        // console.error('发生错误:', error)
        obj.dataList = []
        obj.total = 0
        obj.page = 1
        obj.date = ''
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chg = parseFloat(item.chg).toFixed(2)
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
          item.volForSort = parseFloat(item.vol)
          item.vol = bigNumberTransform(parseFloat(item.vol / 100)) // 总量计算方式：vol除以100，把股转为手
          item.turnoverForSort = parseFloat(item.turnover)
          item.turnover = bigNumberTransform(parseFloat(item.turnover))
          item.turnoverRate_ma1 = (item.turnoverRate_ma1 * 100).toFixed(2) + '%'
          item.amplitude = (item.amplitude * 100).toFixed(2) + '%'
        }
        item.no = no
        no++

        if (item.index == "") {
          item.index = "-"
        }
        if (item.industry == "") {
          item.industry = "-"
        }
        if (item.district == "") {
          item.district = "-"
        }
      })
      obj.total = data.total
      obj.dataList = data.data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'selectedBlockValue': obj.selectedBlockValue,
        'selectedIndexValue': obj.selectedIndexValue,
        'selectedIndustryValue': obj.selectedIndustryValue,
        'selectedDistrictValue': obj.selectedDistrictValue,
        // 基础指标
        'basicValue': obj.basicValue,
        'basicLabel': obj.basicLabel,
        'basicDayValue': obj.basicDayValue,
        'basicDayLabel': obj.basicDayLabel,
        'basicSymbolsValue': obj.basicSymbolsValue,
        'basicSymbolsLabel': obj.basicSymbolsLabel,
        'basicAmount': obj.basicAmount,
        // 财务指标
        'financeValue': obj.financeValue,
        'financeLabel': obj.financeLabel,
        'financeSymbolsValue': obj.financeSymbolsValue,
        'financeSymbolsLabel': obj.financeSymbolsLabel,
        'financeAmount': obj.financeAmount,
        // 技术和形态指标
        'indicatorsValue': obj.indicatorsValue,
        'indicatorsLabel': obj.indicatorsLabel,
        'patternsValue': obj.patternsValue,
        'patternsLabel': obj.patternsLabel,
        // 金融指标
        'selectedJRValue': obj.selectedJRValue,
        'selectedJRLabel': obj.selectedJRLabel,
        'selectedJRDayValue': obj.selectedJRDayValue,
        'selectedJRDayLabel': obj.selectedJRDayLabel,
        'selectedJRSymbolsValue': obj.selectedJRSymbolsValue,
        'selectedJRSymbolsLabel': obj.selectedJRSymbolsLabel,
        'selectedJRAmount': obj.selectedJRAmount,
        'selectJRDayList': obj.selectJRDayList, // 避免切换页面显示失效问题
        // 其他
        'pickingList': obj.pickingList,
        'dataList': obj.dataList,
        'date': obj.date,
        'total': obj.total,
        'page': obj.page,
      }
      store.commit('setPickingData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.selectedBlockValue = store.state.pickingData.selectedBlockValue
      obj.selectedIndexValue = store.state.pickingData.selectedIndexValue
      obj.selectedIndustryValue = store.state.pickingData.selectedIndustryValue
      obj.selectedDistrictValue = store.state.pickingData.selectedDistrictValue
      // 基础指标
      obj.basicValue = store.state.pickingData.basicValue
      obj.basicLabel = store.state.pickingData.basicLabel
      obj.basicDayValue = store.state.pickingData.basicDayValue
      obj.basicDayLabel = store.state.pickingData.basicDayLabel
      obj.basicSymbolsValue = store.state.pickingData.basicSymbolsValue
      obj.basicSymbolsLabel = store.state.pickingData.basicSymbolsLabel
      obj.basicAmount = store.state.pickingData.basicAmount
      // 财务指标
      obj.financeValue = store.state.pickingData.financeValue
      obj.financeLabel = store.state.pickingData.financeLabel
      obj.financeSymbolsValue = store.state.pickingData.financeSymbolsValue
      obj.financeSymbolsLabel = store.state.pickingData.financeSymbolsLabel
      obj.financeAmount = store.state.pickingData.financeAmount
      // 技术和形态指标
      obj.indicatorsValue = store.state.pickingData.indicatorsValue
      obj.indicatorsLabel = store.state.pickingData.indicatorsLabel
      obj.patternsValue = store.state.pickingData.patternsValue
      obj.patternsLabel = store.state.pickingData.patternsLabel
      // 金融指标
      obj.selectedJRValue = store.state.pickingData.selectedJRValue
      obj.selectedJRLabel = store.state.pickingData.selectedJRLabel
      obj.selectedJRDayValue = store.state.pickingData.selectedJRDayValue
      obj.selectedJRDayLabel = store.state.pickingData.selectedJRDayLabel
      obj.selectedJRSymbolsValue = store.state.pickingData.selectedJRSymbolsValue
      obj.selectedJRSymbolsLabel = store.state.pickingData.selectedJRSymbolsLabel
      obj.selectedJRAmount = store.state.pickingData.selectedJRAmount
      obj.selectJRDayList = store.state.pickingData.selectJRDayList // 避免切换页面显示失效问题
      // 其他
      obj.pickingList = store.state.pickingData.pickingList
      obj.dataList = store.state.pickingData.dataList
      obj.date = store.state.pickingData.date
      obj.total = store.state.pickingData.total
      obj.page = store.state.pickingData.page
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      // requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 基本指标 指标名
    const handleBasicValueChange = (e) => {
      let tempObj = findObjByField(obj.basicList, 'value', obj.basicValue)
      obj.basicLabel = tempObj.label
    }

    // 基本指标 范围
    const handleBasicDayValueChange = () => {
      let tempObj = findObjByField(obj.basicDayList, 'value', obj.basicDayValue)
      obj.basicDayLabel = tempObj.label
    }

    // 基本指标 符号
    const handleBasicSymbolsChange = () => {
      let tempObj = findObjByField(obj.symbolsList, 'value', obj.basicSymbolsValue)
      obj.basicSymbolsLabel = tempObj.label
    }

    // 基本指标添加事件
    const handleAddBasic = () => {
      if (obj.basicValue !== "" && obj.basicDayValue !== "" && obj.basicSymbolsValue !== "" && obj.basicAmount !== null) {
        if (isPickingItemMax()) {
          return
        }
        // if (isPickingItemExist(obj.basicLabel)) {
        //   return
        // }
        // 处理有百分号的情况
        var basicAmountValue = 0
        var basicPickingLabel = ""
        if (obj.basicValue == "turnoverRate" || obj.basicValue == "chgPct" || obj.basicValue == "chg2Pct" || obj.basicValue == "amplitude" || obj.basicValue == "volChgPct" || obj.basicValue == "turnoverChgPct") {
          basicAmountValue = obj.basicAmount / 100
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "%"
        } else if (obj.basicValue == "amplitudePoint") {
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "元"
        } else if (obj.basicValue == "vol" || obj.basicValue == "volChg") {
          basicAmountValue = obj.basicAmount * 10000 * 100
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "万手"
        } else if (obj.basicValue == "turnover" || obj.basicValue == "turnoverChg") {
          basicAmountValue = obj.basicAmount * 100000000
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount + "亿"
        } else {
          basicAmountValue = obj.basicAmount
          basicPickingLabel = obj.basicLabel + obj.basicDayLabel + obj.basicSymbolsLabel + obj.basicAmount
        }
        var basicPickingValue = obj.basicValue + "_ma" + obj.basicDayValue + "," + obj.basicSymbolsValue + "," + basicAmountValue
        var basicPickingType = obj.basicLabel

        // 如果指标已经存在则更新，否则做新增
        let exist = false
        for (var item of obj.pickingList) {
          // console.log(item)
          // console.log(item.value)
          // console.log(basicPickingValue)
          // if (item.type == basicPickingType) {
          //   item.label = basicPickingLabel
          //   item.value = basicPickingValue
          //   exist = true
          // }
          // 如果指标条件完全一样，则提示重复(chgPct_ma1,<,1 == chgPct_ma1,<,1)
          if (item.value == basicPickingValue) {
            ElMessage.error("该指标已被添加")
            exist = true
          } else if (item.value.split(",").slice(0, 2).join(",") == basicPickingValue.split(",").slice(0, 2).join(",")) {
            // 如果指标条件数值不一样，则做更新(chgPct_ma1,<,1 != chgPct_ma1,>,0)
            item.label = basicPickingLabel
            item.value = basicPickingValue
            exist = true
          }
        }
        if (!exist) {
          obj.pickingList.push({ label: basicPickingLabel, value: basicPickingValue, type: basicPickingType, category: "basic" })
        }
        console.log(basicPickingValue)
      }
    }

    // 财务指标 指标名
    const handleFinanceValueChange = () => {
      let tempObj = findObjByField(obj.financeList, 'value', obj.financeValue)
      obj.financeLabel = tempObj.label
    }

    // 财务指标 符号
    const handleFinanceSymbolsChange = () => {
      let tempObj = findObjByField(obj.symbolsList, 'value', obj.financeSymbolsValue)
      obj.financeSymbolsLabel = tempObj.label
    }

    // 财务指标添加事件
    const handleAddFinance = () => {
      if (obj.financeValue !== "" && obj.financeSymbolsValue !== "" && obj.financeAmount !== null) {
        if (isPickingItemMax()) {
          return
        }
        // if (isPickingItemExist(obj.financeLabel)) {
        //   return
        // }
        // 处理有百分号项目和亿单位项目
        var financeAmountValue = 0
        var financePickingLabel = ""
        if (obj.financeValue == "debtRatio" || obj.financeValue == "profitYoY" || obj.financeValue == "revenueYoY" || obj.financeValue == "ROE" || obj.financeValue == "grossProfitMargin" || obj.financeValue == "operatingProfitMargin" || obj.financeValue == "netProfitMargin") {
          financeAmountValue = obj.financeAmount / 100
          financePickingLabel = obj.financeLabel + obj.financeSymbolsLabel + obj.financeAmount + "%"
        } else if (obj.financeValue == "floatingStock" || obj.financeValue == "circulatingMarketValue" || obj.financeValue == "totalAssets" || obj.financeValue == "netAssets" || obj.financeValue == "revenue" || obj.financeValue == "cost" || obj.financeValue == "profit" ||
          obj.financeValue == "investmentIncome" || obj.financeValue == "totalProfits" || obj.financeValue == "profitAfterTax" || obj.financeValue == "netProfit" || obj.financeValue == "nonGAAPNetProfit" || obj.financeValue == "retainedEarnings" || obj.financeValue == "operatingCashFlow" || obj.financeValue == "totalCashFlow") {
          financeAmountValue = obj.financeAmount
          financePickingLabel = obj.financeLabel + obj.financeSymbolsLabel + obj.financeAmount + "亿"
        } else {
          financeAmountValue = obj.financeAmount
          financePickingLabel = obj.financeLabel + obj.financeSymbolsLabel + obj.financeAmount
        }
        var financePickingValue = obj.financeValue + "," + obj.financeSymbolsValue + "," + financeAmountValue
        var financePickingType = obj.financeLabel

        // 如果指标已经存在则更新，否则做新增
        let exist = false
        for (var item of obj.pickingList) {
          // if (item.type == financePickingType) {
          //   item.label = financePickingLabel
          //   item.value = financePickingValue
          //   exist = true
          // }
          // 如果指标条件完全一样，则提示重复(chgPct_ma1,<,1 == chgPct_ma1,<,1)
          if (item.value == financePickingValue) {
            ElMessage.error("该指标已被添加")
            exist = true
          } else if (item.value.split(",").slice(0, 2).join(",") == financePickingValue.split(",").slice(0, 2).join(",")) {
            // 如果指标条件数值不一样，则做更新(chgPct_ma1,<,1 != chgPct_ma1,>,0)
            item.label = financePickingLabel
            item.value = financePickingValue
            exist = true
          }
        }
        if (!exist) {
          obj.pickingList.push({ label: financePickingLabel, value: financePickingValue, type: financePickingType, category: "finance" })
        }
        console.log(financePickingValue)
      }
    }

    // 技术指标 指标名
    const handleTechnicalChange = () => {
      for (var item of obj.indicatorsList) {
        let tempObj = findObjByField(item.options, 'value', obj.indicatorsValue)
        if (tempObj != null) {
          obj.indicatorsLabel = tempObj.label
          break
        }
      }
    }

    // 技术指标添加事件
    const handleAddTechnical = () => {
      if (obj.indicatorsValue !== "") {
        if (isPickingItemMax()) {
          return
        }
        if (isPickingItemExist(obj.indicatorsLabel)) {
          return
        }
        var indicatorsPickingValue = obj.indicatorsValue
        var indicatorsPickingLabel = obj.indicatorsLabel
        var indicatorsPickingType = obj.indicatorsLabel
        obj.pickingList.push({ label: indicatorsPickingLabel, value: indicatorsPickingValue, type: indicatorsPickingType, category: "technical" })
        console.log(indicatorsPickingValue)
      }
    }

    // 形态指标 指标名
    const handlePatternChange = () => {
      for (var item of obj.patternsList) {
        let tempObj = findObjByField(item.options, 'value', obj.patternsValue)
        if (tempObj != null) {
          obj.patternsLabel = tempObj.label
          break
        }
      }
    }

    // 形态指标添加事件
    const handleAddPattern = () => {
      if (obj.patternsValue !== "") {
        if (isPickingItemMax()) {
          return
        }
        if (isPickingItemExist(obj.patternsLabel)) {
          return
        }
        var patternPickingValue = obj.patternsValue
        var patternPickingLabel = obj.patternsLabel
        var patternPickingType = obj.patternsLabel
        obj.pickingList.push({ label: patternPickingLabel, value: patternPickingValue, type: patternPickingType, category: "pattern" })
        console.log(patternPickingValue)
      }
    }

    // 金融指标 指标名
    const handleJRChange = (value) => {
      if (value === "alpha" || value === "beta" || value === "correlation") {
        obj.selectJRDayList = [{ value: '60', label: '最近60日' }]
        obj.selectedJRDayValue = '60'
        obj.selectedJRDayLabel = '最近60日'
        setStore() // 避免切换页面回来，显示失效问题
      } else {
        // obj.selectJRDayList = [{ value: '5', label: '最近5日' }, { value: '10', label: '最近10日' }, { value: '20', label: '最近20日' }, { value: '60', label: '最近60日' }]
        obj.selectJRDayList = [{ value: '5', label: '最近5日' }, { value: '10', label: '最近10日' }, { value: '20', label: '最近20日' }]
        obj.selectedJRDayValue = ''
        obj.selectedJRDayLabel = ''
      }
      let tempObj = findObjByField(obj.selectJRList, 'value', obj.selectedJRValue)
      obj.selectedJRLabel = tempObj.label
    }

    // 金融指标 范围
    const handleJRDayChange = () => {
      let tempObj = findObjByField(obj.selectJRDayList, 'value', obj.selectedJRDayValue)
      obj.selectedJRDayLabel = tempObj.label
    }

    // 金融指标 符号
    const handleJRSymbolsChange = () => {
      let tempObj = findObjByField(obj.symbolsList, 'value', obj.selectedJRSymbolsValue)
      obj.selectedJRSymbolsLabel = tempObj.label
    }

    // 金融指标添加事件
    const handleAddJR = () => {
      if (obj.selectedJRValue !== "" && obj.selectedJRDayValue !== "" && obj.selectedJRSymbolsValue !== "" && obj.selectedJRAmount !== null) {
        if (isPickingItemMax()) {
          return
        }
        // if (isPickingItemExist(obj.selectedJRLabel)) {
        //   return
        // }
        // 处理有百分号的情况
        var jrAmountValue = 0
        var jrPickingLabel = ""
        if (obj.selectedJRValue == "rtn" || obj.selectedJRValue == "std") {
          jrAmountValue = obj.selectedJRAmount / 100
          jrPickingLabel = obj.selectedJRLabel + obj.selectedJRDayLabel + obj.selectedJRSymbolsLabel + obj.selectedJRAmount + "%"
        } else {
          jrAmountValue = obj.selectedJRAmount
          jrPickingLabel = obj.selectedJRLabel + obj.selectedJRDayLabel + obj.selectedJRSymbolsLabel + obj.selectedJRAmount
        }
        var jrPickingValue = obj.selectedJRValue + "_ma" + obj.selectedJRDayValue + "," + obj.selectedJRSymbolsValue + "," + jrAmountValue
        var jrPickingType = obj.selectedJRLabel

        // 如果指标已经存在则更新，否则做新增
        let exist = false
        for (var item of obj.pickingList) {
          // if (item.type == jrPickingType) {
          //   item.label = jrPickingLabel
          //   item.value = jrPickingValue
          //   exist = true
          // }
          if (item.value == jrPickingValue) {
            ElMessage.error("该指标已被添加")
            exist = true
          } else if (item.value.split(",").slice(0, 2).join(",") == jrPickingValue.split(",").slice(0, 2).join(",")) {
            // 如果指标条件数值不一样，则做更新(chgPct_ma1,<,1 != chgPct_ma1,>,0)
            item.label = jrPickingLabel
            item.value = jrPickingValue
            exist = true
          }
        }
        if (!exist) {
          obj.pickingList.push({ label: jrPickingLabel, value: jrPickingValue, type: jrPickingType, category: "return" })
        }
        console.log(jrPickingValue)
      }
    }

    // 指标项目最大添加数量check
    const isPickingItemMax = () => {
      if (obj.pickingList.length == 8) {
        ElMessage.error("最多只能添加8个指标")
        return true
      }
      return false
    }

    // 指标项目是否已被添加check
    const isPickingItemExist = (pickingItem) => {
      for (var item of obj.pickingList) {
        // console.log(obj.pickingList)
        // console.log(pickingItem)
        if (item.type == pickingItem) {
          ElMessage.error("该指标已被添加")
          return true
        }
      }
      return false
    }

    // 删除品种
    const del = (data) => {
      obj.pickingList.forEach((item) => {
        // console.log(data)
        if (item.value === data.value) {
          // console.log(item.value)
          obj.pickingList.splice(obj.pickingList.indexOf(item), 1)
        }
      })
    }

    // 按钮提交事件
    const handleSubmit = () => {
      if (!formCheck()) {
        return
      }
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.pickingList.length === 0) {
        ElMessage.error('请至少添加一个筛选条件')
        return false
      }
      return true
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      obj.page = value
      requestData()
    };

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.open > row.row.preClose && row.columnIndex === 6) {
        return { color: 'red' }
      } else if (row.row.open < row.row.preClose && row.columnIndex === 6) {
        return { color: 'green' }
      }
      if (row.row.low > row.row.preClose && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.low < row.row.preClose && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.high > row.row.preClose && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.high < row.row.preClose && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.close > row.row.preClose && row.columnIndex === 3) {
        return { color: 'red' }
      } else if (row.row.close < row.row.preClose && row.columnIndex === 3) {
        return { color: 'green' }
      }
      if (row.row.trend_ma1 > 0 && row.columnIndex === 12) {
        return { color: 'red' }
      } else if (row.row.trend_ma1 < 0 && row.columnIndex === 12) {
        return { color: 'green' }
      }
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    // 表格排序(带金额单位的数字列)
    const customVolSort = (a, b) => {
      return a.volForSort - b.volForSort
    }

    // 表格排序(带金额单位的数字列)
    const customTurnoverSort = (a, b) => {
      return a.turnoverForSort - b.turnoverForSort
    }

    // 表格排序(带百分号的数字列)
    const customTurnoverRateSort = (a, b) => {
      return parseFloat(a.turnoverRate_ma1.replace('%', '')) - parseFloat(b.turnoverRate_ma1.replace('%', ''))
    }

    // 表格排序(带百分号的数字列)
    const customAmplitudeSort = (a, b) => {
      return parseFloat(a.amplitude.replace('%', '')) - parseFloat(b.amplitude.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSubmit,
      handleSelectChange,
      handleRowClick,
      handleBasicValueChange,
      handleBasicDayValueChange,
      handleBasicSymbolsChange,
      handleAddBasic,
      handleFinanceValueChange,
      handleFinanceSymbolsChange,
      handleAddFinance,
      handleTechnicalChange,
      handlePatternChange,
      handleAddTechnical,
      handleAddPattern,
      handleJRChange,
      handleJRDayChange,
      handleJRSymbolsChange,
      handleAddJR,
      del,
      cellStyle,
      customPctSort,
      customVolSort,
      customTurnoverSort,
      customTurnoverRateSort,
      customAmplitudeSort,
      handlePageChange
    }
  }
}
</script>
<style lang="scss" scoped></style>